var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage-details"},[_c('TextBlockWithLabel',{attrs:{"text-label":{ text: _vm.$t('_web_tournament_stage', 'Stage') },"text-block":{ text: _vm.title, size: 0.875 }}}),_c('TextBlockWithLabel',{attrs:{"text-label":{
      text: _vm.$t('_web_tournament_stage-check-in', 'Stage check in'),
    },"text-block":{ text: _vm.checkInTime, size: 0.875 }}}),_c('TextBlockWithLabel',{staticClass:"text-capitalize",attrs:{"text-label":{ text: _vm.$t('_web_tournament_stage-type', 'Type') },"text-block":{
      text: _vm.$t(("_web_tournament_stage-type-name_" + _vm.type), _vm.type),
      size: 0.875,
    }}}),_c('TextBlockWithLabel',{staticClass:"text-capitalize",attrs:{"text-label":{
      text: _vm.$t('_web_tournament_stage_type-of-stage-label', 'Type of stage'),
    },"text-block":{
      text: _vm.$t(
        ("_web_tournament_stage_available-" + _vm.availabilityType),
        _vm.availabilityType
      ),
      size: 0.875,
    }}}),_c('TextBlockWithLabel',{staticClass:"text-capitalize",attrs:{"text-label":{ text: _vm.$t('_web_tournament_stage_location', 'Location') },"text-block":{ text: _vm.location, size: 0.875 }}}),(_vm.locationImages.length)?_c('div',{staticClass:"row"},_vm._l((_vm.locationImages),function(img,index){return _c('div',{key:index,staticClass:"col-3 mb-4"},[_c('img',{staticClass:"mw-100 cursor-hand stage-details_map",attrs:{"src":img},on:{"click":function($event){return _vm.openImage(img)}}})])}),0):_vm._e(),_c('TextBlockWithLabel',{attrs:{"text-label":{
      text: _vm.$t('_web_tournament_best-of-final', 'Best of (final match)'),
    },"text-block":{ text: _vm.bestOfFinal, size: 0.875 }}}),_c('TextBlockWithLabel',{attrs:{"text-label":{
      text: _vm.$t('_web_tournament_number-of-rounds', 'Number of rounds'),
    },"text-block":{ text: _vm.numberOfRounds, size: 0.875 }}}),_c('TextBlockWithLabel',{attrs:{"text-label":{
      text: _vm.$t('_web_tournament_3rd_place-label', 'Match for the 3rd place'),
    },"text-block":{
      text: _vm.$t(
        ("_web_tournament_3rd_place-variant-" + _vm.match3dPlace),
        _vm.match3dPlace
      ),
      size: 0.875,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }